module.exports = __webpack_public_path__ + "img/icone-esfiharia.81b5ff98.svg";